import type { WishItem } from "../../models/contracts";

export const wishAuthor = (wish: WishItem): string =>
  wish.isAnonymous || !wish.authorDisplayName ? "Someone at your party" : wish.authorDisplayName;

export const WishCard = ({ wish, index, featured = false, focusId = null }: { wish: WishItem; index: number; featured?: boolean; focusId?: string | null }) => (
  <blockquote
    class={`wish-theme-card wish-card-${index + 1}${featured ? " is-featured" : ""}${focusId === wish.id ? " is-focused" : focusId ? " is-receding" : ""}`}
    dir="auto"
  >
    <span class="wish-quote" aria-hidden="true">“</span>
    <p>{wish.text}</p>
    <cite>— {wishAuthor(wish)}</cite>
  </blockquote>
);
